import { render } from "./PosRightbar.vue?vue&type=template&id=e7010f6a&scoped=true"
import script from "./PosRightbar.vue?vue&type=script&lang=js"
export * from "./PosRightbar.vue?vue&type=script&lang=js"

import "./PosRightbar.vue?vue&type=style&index=0&id=e7010f6a&scoped=true&lang=css"

import exportComponent from "D:\\xampp7\\htdocs\\24x7pos\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e7010f6a"]])

export default __exports__